import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const updateWorker = async (worker, action) => {
  try {
    let { status } = await axios.put(`/v1/worker`, { worker, action });
    return status;
  } catch (e) {
    console.log("error while updating worker ....", e.response);
    if (e.response) {
      let {
        response: { status },
      } = e;
      if (status === 405) {
        addNotification({
          title: "Techforce.ai",
          message: "Please write for technical support",
          type: "danger",
        });
      } else if (status === 403) {
        addNotification({
          title: "Techforce.ai",
          message: "You don't have enough permission to update worker",
          type: "danger",
        });
      }
    } else {
      addNotification({
        title: "Techforce.ai",
        message: "working on updating your e-worker",
        type: "info",
      });
    }
  }
};
